export default __webpack_public_path__ + "static/video3-6b4db7b2e88cbf22f67cb4f26c65a30b.mp4";